/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManagedUserPermissionsPayload } from './ManagedUserPermissionsPayload';
export type UpdateManagedUserPayload = {
    firstName: string;
    lastName: string;
    title?: string | null;
    gender?: UpdateManagedUserPayload.gender;
    permissions?: ManagedUserPermissionsPayload;
    isActive?: boolean;
};
export namespace UpdateManagedUserPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

